module.exports = __webpack_public_path__ + "img/1554218999.532cff94.jpg";